(function () {
  Flint.file("views/carouselCards/textingTipsCard.js", function (require) {
    Flint.staticStyles("TextingTipsCard", {
      "$Link": "#_flintapp .ViewTextingTipsCard .ViewLink"
    }, {
      "$Link": {
        alignSelf: 'stretch',
        flexGrow: 1,

        backgroundSize: 'contain',
        backgroundPosition: '50% 50%',
        backgroundRepeat: 'no-repeat'
      }
    });
    Flint.view("TextingTipsCard", function (view, on, $) {
      ;view.render(function () {
        return view.el(["Link", 1], { to: "https://texting.tips", target: "_blank" });
      });

      "1ee447cb";

      $["Link"] = function (_, _index) {
        return { backgroundImage: "url(/images/carousel/textingtips.png)" };
      };
    });
  })
})();
//# sourceMappingURL=textingTipsCard.js.map
